import { useEffect, useState } from "react";

const NoPage = () => {
  const [prevPath, setPrevPath] = useState(null);
  const [currentPath, setCurrentPath] = useState(null);

  useEffect(() => {
    setPrevPath(sessionStorage.getItem("prevPath"));
    setCurrentPath(sessionStorage.getItem("currentPath"));
  }, []);

  return (
    <div style={{ height: "100%", width: "100%", display: "grid", fontFamily : "cursive" }}>
      <div className="text-center" style={{ margin: "auto" }}>
        <div className="error mx-auto" data-text="404" style={{fontSize: "50px", }}>404</div>
        <p className="lead text-gray-800 mb-5">Page Not Found</p>
        <p className="text-gray-500 mb-3" style={{fontSize: "15px"}}>
          Oops! The route <strong>{prevPath}</strong> doesn’t exist.
        </p>

        <a href={"/"} style={{color : "blue"}}>&larr; Back to Home</a>
      </div>
    </div>
  );
};

export default NoPage;

